import { isToday, isYesterday } from "@app/app.helper";
import { EvideTableColumn, EvideTableColumnType } from "../common/common.model";

export interface INotificationTaskHttpResponse {
    id: number;
    isViewed: boolean;
    taskDateTime: Date;
    messageContent: string;
    inititorUserName: string;
    inititorLicense: string;
    taskLink: string;
}

export class NotificationTask {
    public readonly taskDateStr: string;

    constructor(
        public id: number,
        public isViewed: boolean,
        public taskDateTime: Date,
        public messageContent: string,
        public inititorUserName: string,
        public inititorLicense: string,
        public taskLink: string
    ) {
        let tmpDateTime = new Date(taskDateTime);
        if (isToday(tmpDateTime)) {
            this.taskDateStr = 'Today';
        } else if (isYesterday(tmpDateTime)) {
            this.taskDateStr = 'Yesterday';
        } else {
            this.taskDateStr = `${tmpDateTime.getFullYear()}/${(tmpDateTime.getMonth() + 1)}/${tmpDateTime.getDate()}`;
        }
    }

    public static adapt(data: INotificationTaskHttpResponse) {
        return new this(
            data.id,
            data.isViewed,
            data.taskDateTime,
            data.messageContent,
            data.inititorUserName,
            data.inititorLicense,
            data.taskLink
        );
    }

    public static createBlank() {
        return new this(0, false, new Date(), '', '', '', '');
    }
}
